<template>
    <div
        class="fixed left-0 top-0 z-[var(--z-landscapes)] h-full w-full text-base-white"
    >
        <div
            class="slt-gsap-landscapes slt-max-content-center relative h-[600vh] [--padding-lg:104px] [--padding-sm:theme(spacing.8)]"
        >
        <!-- TODO: hidden flex temp -->
            <div
                class="hidden slt-gsap-landscapes-title h-screen flex-col gap-5 px-[var(--padding-base)] pt-[20vh] sm:px-[7vw] lg:px-[var(--padding-lg)]"
            >
                <AtomsH4
                    class="text-base-white/80 sm:hidden"
                    v-if="shouldRender(landscapes?.title)"
                >
                    {{ renderLines(landscapes?.title) }}
                </AtomsH4>
                <AtomsH5
                    class="hidden text-left text-base-white/80 sm:block"
                    v-if="shouldRender(landscapes?.title)"
                >
                    {{ renderLines(landscapes?.title) }}
                </AtomsH5>
                <AtomsH1
                    v-if="shouldRender(landscapes?.subtitle)"
                    :html="renderLines(landscapes?.subtitle)"
                />

                <AtomsBody1
                    class="text-base-white/80"
                    v-if="shouldRender(landscapes?.minorText)"
                    :html="renderLines(landscapes?.minorText)"
                />
            </div>
            <div
                class="slt-gsap-landscapes-content absolute left-0 top-0 h-screen w-full pt-[108px] [--grid-gap:theme(spacing.3)] sm:pt-[215px] lg:pt-[204px]"
            >
                <AtomsH5
                    v-if="shouldRender(landscapes?.title)"
                    class="mb-4 px-[var(--padding-base)] text-left text-base-white/80 sm:max-w-[min(44vw,456px)] sm:px-[var(--padding-sm)] lg:mb-6 lg:max-w-[min(41.42vw,796px)] lg:px-[var(--padding-lg)]"
                >
                    {{ renderLines(landscapes?.title) }}
                </AtomsH5>
                <div
                    class="relative overflow-hidden px-[var(--scoped-padding-base)] [--scoped-padding-base:calc(var(--padding-base))] [--scoped-padding-lg:calc(var(--padding-lg)-var(--grid-gap))] [--scoped-padding-sm:var(--padding-sm)] sm:px-[var(--scoped-padding-sm)] lg:w-[80%] lg:px-[var(--scoped-padding-lg)]"
                >
                    <template v-for="i in 2" :key="i">
                        <div
                            class="flex w-[400%] gap-[var(--grid-gap)] lg:w-[200%]"
                            :class="[
                                `${i === 2 ? 'mt-[var(--grid-gap)] sm:hidden' : ''}`,
                                { 'sm:w-[200%]': locale === 'zh' },
                                { 'sm:w-[300%]': locale !== 'zh' },
                            ]"
                            :style="`transform: translateX(calc(${
                                snappedLandscapesProgress * -50
                            }% - ${(snappedLandscapesProgress * 6).toFixed(2)}px))`"
                            v-if="i === 1 || (i === 2 && winWidth < 640)"
                        >
                            <ul
                                class="slt-gsap-landscapes-tags grid flex-1 grid-cols-6 grid-rows-1 gap-[var(--grid-gap)]"
                                v-for="j in 2"
                                :key="j"
                            >
                                <li
                                    v-for="(l, idx) in getReorderedLandscapes(
                                        landscapes?.data,
                                        i,
                                    )"
                                    :key="idx"
                                    :class="
                                        twMerge(
                                            'slt-flex-center cursor-pointer select-none rounded-full py-2 sm:py-3',
                                        )
                                    "
                                    :style="
                                        i === 2
                                            ? getColorMix(0)
                                            : computeHighlightStyle(idx, j)
                                    "
                                    @click="selectLandscape(idx, i)"
                                >
                                    <AtomsH4
                                        v-if="shouldRender(l.name)"
                                        class="!text-center !text-[3.56vw] xs:!text-[14px]"
                                    >
                                        {{ renderLines(l.name) }}
                                    </AtomsH4>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <span
                        v-for="i in 2"
                        :key="i"
                        class="absolute top-0 h-full w-[var(--scoped-padding-base)] from-black from-50% to-transparent sm:w-[var(--scoped-padding-sm)] sm:from-70% lg:w-[var(--scoped-padding-lg)] lg:from-90%"
                        :class="`${i === 1 ? 'right-0 bg-gradient-to-l' : 'left-0 bg-gradient-to-r'}`"
                    />
                </div>

                <div
                    class="mt-6 px-[var(--padding-base)] sm:max-w-[min(44vw,456px)] sm:px-[var(--padding-sm)] lg:mt-12 lg:max-w-[min(41.42vw,796px)] lg:px-[var(--padding-lg)]"
                >
                    <Transition name="fade" mode="out-in">
                        <div
                            :key="activeLandscapeIndex"
                            class="flex flex-col gap-6 sm:gap-8 lg:gap-12"
                            v-if="shouldRender(landscapes?.data)"
                        >
                            <AtomsH5
                                class="text-left"
                                v-if="
                                    shouldRender(
                                        landscapes?.data[activeLandscapeIndex]
                                            ?.description,
                                    )
                                "
                            >
                                {{
                                    renderLines(
                                        landscapes.data[activeLandscapeIndex]
                                            ?.description,
                                    )
                                }}
                            </AtomsH5>
                            <ul
                                class="grid grid-cols-3 gap-2 sm:grid-cols-2 sm:gap-3 lg:w-fit"
                                v-if="
                                    shouldRender(
                                        landscapes.data[activeLandscapeIndex]
                                            ?.brands,
                                    )
                                "
                            >
                                <li
                                    v-for="b in landscapes.data[
                                        activeLandscapeIndex
                                    ].brands"
                                    :key="b.name"
                                    :class="
                                        twMerge(
                                            'slt-flex-center h-[58px] w-full max-w-full overflow-hidden rounded-2xl bg-base-white sm:h-[72px] lg:w-[170px] lg:rounded-3xl',
                                            b.meta_box?.brand?.href &&
                                                !Array.isArray(
                                                    b.meta_box?.brand?.href,
                                                ) &&
                                                'cursor-pointer',
                                        )
                                    "
                                    @click="handleBrandClick(b)"
                                    v-sendGAsignal="{
                                        event_category: 'about.brands',
                                        event_label: b?.meta_box?.brand?.name,
                                    }"
                                >
                                    <img
                                        v-if="shouldRender(b.featured_media)"
                                        :src="b.featured_media.source_url"
                                        :alt="b.featured_media.alt_text"
                                        :width="
                                            b?.featured_media?.media_details
                                                ?.width
                                        "
                                        :height="
                                            b?.featured_media?.media_details
                                                ?.height
                                        "
                                        class="h-auto w-[90%] object-contain"
                                    />
                                </li>
                            </ul>
                        </div>
                    </Transition>
                </div>
            </div>
        </div>
        <!-- Skip Button -->
         <!-- TODO: temp hidden flex -->
        <div class="slt-gsap-skip-button"></div>
        <div
            class="hidden absolute bottom-6 right-[var(--padding-base)] cursor-pointer items-center gap-1 text-primary-orange duration-150 ease-in-out hover:gap-2 sm:bottom-10 sm:right-[var(--padding-sm)] lg:right-10"
            @click="skipMilestones"
            v-sendGAsignal="{
                event_category: 'about.milestones',
                event_label: 'skip',
            }"
        >
            <AtomsH4 class="font-en">SKIP</AtomsH4>
            <SvgArrowFastForward class="h-6 w-6" />
        </div>
    </div>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import { organismLandscapesAnimate } from "@/lib/gsap-about";
import { killAnimation } from "@/lib/gsap-core";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { renderLines, shouldRender } from "~/lib/utils";
import { gsap } from "gsap";

const props = defineProps({
    landscapes: {
        type: Object,
        required: true,
    },
});
const { locale } = useI18n();
const { width: winWidth } = useWindowSize();
const { landscapesProgress } = useLandscapesProgress();
const selectedLandscape = ref(0);
const landscapesLength = computed(() => props.landscapes?.data?.length || 1);
const snappedLandscapesProgress = computed(() => {
    return selectedLandscape.value / landscapesLength.value;
});
const skipMilestones = () => {
    const st = ScrollTrigger.getById("stLandscapes");
    if (!st) {
        // console.error("ScrollTrigger instance 'stLandscapes' not found.");
        return;
    }
    const timelineDuration = tl.duration(); // timeline 總長度（秒）
    const progressRatio = 1.5 / timelineDuration; // 動畫開始時間佔 timeline 百分比

    // 計算滾動目標位置（start 到 end）
    const scrollStart = st.start; // 觸發開始滾動位置
    const scrollEnd = st.end; // 觸發結束位置（如果有設定）
    const scrollTarget =
        scrollStart + (scrollEnd - scrollStart) * progressRatio;

    // 依比例計算滾動位置
    gsap.to(window, {
        duration: 1, // Duration of the scroll animation
        scrollTo: scrollTarget, // Target scroll position
        ease: "power2.inOut", // Easing function for smoothness
    });
};
const activeLandscapeIndex = computed(() => {
    // Add safety check
    if (!props.landscapes?.data || props.landscapes.data.length === 0) return 0;
    return Math.round(selectedLandscape.value - 0.3) % landscapesLength.value;
});

const COLOR_CACHE = new Map();
function getColorMix(percent, opacity = "1") {
    // Round to nearest 0.05 to reduce unique calculations (20 steps is smooth enough)
    const roundedPercent = Math.round(percent * 20) / 20;

    const cacheKey = roundedPercent.toString();

    if (COLOR_CACHE.has(cacheKey)) {
        return COLOR_CACHE.get(cacheKey);
    }

    const background = `color-mix(in oklab, #FF6400 ${roundedPercent * 100}%, #3E3E3E)`;
    const color = `color-mix(in oklab, #FFFFFF ${roundedPercent * 100}%, #BDBDBD)`;

    const result = { background, color, opacity };
    COLOR_CACHE.set(cacheKey, result);
    return result;
}
function computeHighlightStyle(idx, i) {
    // Early return for default state
    if (!props.landscapes?.data) {
        return getColorMix(0);
    }

    // Handle the FIRST instance of items (i === 1)
    if (i === 1) {
        const distance = Math.abs(selectedLandscape.value - idx);
        const highlight = Math.max(1 - distance, 0);
        // const opacity =
        //     selectedLandscape.value > idx
        //         ? Math.max(1 - distance * 2, 0).toFixed(2)
        //         : "1"; // fade out smoothly to 0.5+
        return getColorMix(highlight);
    }

    // For the REPEATED set (i === 2)
    // if (i === 2) {
    //     // Only highlight the first item in the second set when we're looping
    //     if (idx === 0) {
    //         // Only highlight when we're past the last item of the first set
    //         if (selectedLandscape.value > landscapesLength.value - 1) {
    //             const distance = Math.abs(
    //                 selectedLandscape.value - landscapesLength.value,
    //             );
    //             const highlight = Math.max(1 - distance, 0);
    //             return getColorMix(highlight);
    //         }
    //     }

    //     // Don't highlight any other repeated items
    //     return getColorMix(0);
    // }

    // Default case
    return getColorMix(0);
}
function getReorderedLandscapes(items, idx) {
    if (idx === 2) {
        // For the second array (idx === 2), reorder the items
        return [...items.slice(3), ...items.slice(0, 3)];
    }
    return items;
}

function selectLandscape(visualIndexInRow, rowIndex) {
    if (!props.landscapes?.data || landscapesLength.value === 0) {
        // console.warn("Cannot select landscape: No data or zero length.");
        return;
    }

    const N = landscapesLength.value - 1; // Total number of unique landscape items (e.g., 6)

    const st = ScrollTrigger.getById("stLandscapes");
    if (!st) {
        // console.error("ScrollTrigger instance 'stLandscapes' not found.");
        return;
    }
    if (!tl) {
        // console.error("Main GSAP timeline (tl) instance not found.");
        return;
    }

    const itemsForThisRow = getReorderedLandscapes(
        props.landscapes.data,
        rowIndex,
    );
    if (visualIndexInRow < 0 || visualIndexInRow >= itemsForThisRow.length) {
        // console.error("Clicked visual index is out of bounds for the row.");
        return;
    }
    const clickedItem = itemsForThisRow[visualIndexInRow];
    const targetOriginalIndex = props.landscapes.data.indexOf(clickedItem); // Should be 0 to N-1

    if (targetOriginalIndex === -1) {
        // console.error(
        //     "Clicked item not found in original landscapes.data array.",
        // );
        return;
    }

    const mainTimelineTotalDuration = tl.duration();
    if (mainTimelineTotalDuration <= 0) {
        // console.warn(
        //     "Main timeline duration is zero. Cannot calculate scroll properly.",
        // );
        return;
    }

    const actualProgressTweenDuration = 4; // Duration of animation #5 (the landscapesProgress tween)
    const actualProgressTweenStartTime =
        mainTimelineTotalDuration - actualProgressTweenDuration;

    if (actualProgressTweenStartTime < 0) {
        // console.error(
        //     `Calculated progressTweenStartTime (${actualProgressTweenStartTime}) is negative. Check timeline structure.`,
        // );
        return;
    }

    const mainScrollTriggerStart = st.start;
    const mainScrollTriggerEnd = st.end;
    const mainTimelineScrollRange =
        mainScrollTriggerEnd - mainScrollTriggerStart;

    if (mainTimelineScrollRange <= 0) {
        // console.warn("Main ScrollTrigger's scroll range is not positive.");
        return;
    }

    const scrollStartOfProgressTweenSection =
        mainScrollTriggerStart +
        (actualProgressTweenStartTime / mainTimelineTotalDuration) *
            mainTimelineScrollRange;

    const scrollDistanceCoveredByProgressTween =
        (actualProgressTweenDuration / mainTimelineTotalDuration) *
        mainTimelineScrollRange;

    const targetProgressWithinTargetTweenItself = targetOriginalIndex / N;

    const scrollOffsetWithinProgressTween =
        targetProgressWithinTargetTweenItself *
        scrollDistanceCoveredByProgressTween;

    const targetScrollY =
        scrollStartOfProgressTweenSection + scrollOffsetWithinProgressTween;
    st.scroll(targetScrollY);
}

const handleBrandClick = (brand) => {
    if (
        brand.meta_box?.brand?.href &&
        !Array.isArray(brand.meta_box?.brand?.href)
    ) {
        window.open(brand.meta_box.brand.href, "_blank");
    } else {
        // TEMP: remove any notification
        // $toast.error(t("notification.noBrandLink"));
    }
};

let tl = null;
onMounted(() => {
    tl = organismLandscapesAnimate(
        landscapesProgress,
        landscapesLength,
        selectedLandscape,
    );
});

onBeforeUnmount(() => {
    killAnimation(tl);
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: 0.3s;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}
.fade-enter-to,
.fade-leave-from {
    opacity: 1;
    transform: translateY(0);
}
</style>
